import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Card, CardBody, Col, Input, Row, Table } from "reactstrap";
import {
  GET_RP_AVG_DEMAND,
  GET_RP_AVG_DEMAND_EVENT,
  GET_RP_BY_PASS_GAS,
} from "../../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import BarChartDemandCusType from "../SectionDemandCustomerType/BarChartDemandCusType";
import ByPassChart from "../SectionDemandCustomerType/ByPassChart";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import TableDemandCom from "../SectionDemandCustomerType/TableDemandCom";

// import { post, postUpload } from "../../../helpers/api_helper";

function SectionDemandCustomerType(props) {
  // console.log(props);
  const dispatch = useDispatch();

  const defaultAvgDemandEventModel = {
    PID: "",
    SUMMARYREPORT_PID: props.summaryReportPid,
    AVGDEMAND_STATUS: 0,
    AVGDEMAND_REMARK: "",
  };
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [dataListGraphByPassGas, setDataListGraphByPassGas] = useState([]);
  const [avgDemandEventModel, setAvgDemandEventModel] = useState(
    defaultAvgDemandEventModel
  );
  const [dataListGraph, setDataListGraph] = useState([]);
  const [byPassGas, setByPassGas] = useState({
    BYPASSGAS_VOLUME: 0,
    BYPASS_UNIT: "MMscfd",
  });

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "" || number == undefined) return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());
    setAvgDemandEventModel(defaultAvgDemandEventModel);
    try {
      let [avgDemand, avgDemandEvent, byPassGas, prevByPassGas] =
        await Promise.all([
          post(GET_RP_AVG_DEMAND, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
          post(GET_RP_AVG_DEMAND_EVENT, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
          post(GET_RP_BY_PASS_GAS, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
          post(GET_RP_BY_PASS_GAS, {
            REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
          }),
        ]);

      // let avgDemand = await post(GET_RP_AVG_DEMAND, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682", });
      // console.log(avgDemand, avgDemandEvent, byPassGas);

      // console.log(prevByPassGas.data.rpBypassGasList.filter(row => {
      //   return (
      //     moment(row.REPORT_DATE).format('YYYY-MM-DD') == '2022-07-04'
      //   );
      // }))

      setDataListGraphByPassGas(prevByPassGas.data.rpBypassGasList);
      // console.log(avgDemand);
      setDataListGraph(avgDemand.data.rpAVGDemandModList.sort((a, b) =>
        a.DEMANDCOLUMN_ORDER > b.DEMANDCOLUMN_ORDER
          ? 1
          : b.DEMANDCOLUMN_ORDER > a.DEMANDCOLUMN_ORDER
            ? -1
            : 0
      ));

      if (avgDemandEvent.data.rpAVGDemandEventList.length == 1) {
        setAvgDemandEventModel(avgDemandEvent.data.rpAVGDemandEventList[0]);
      }

      if (byPassGas.data.rpBypassGasList.length == 1) {
        setByPassGas(byPassGas.data.rpBypassGasList[0]);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid]);

  return (
    <Row>

      {/* <Col sm="12"> */}
      <Row className="mt-0">
        <Col sm="6">
          <h5
            className="mb-0 sm-0"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Demand for Customer Types
          </h5>
        </Col>
        <Col sm="6">
          <h5
            className="mb-0 sm-0 d-flex align-items-center justify-content-end"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}

          </h5>
        </Col>
      </Row>

      <Row className="mt-2">
        <hr />
      </Row>

      <div className="d-flex dashboard-content-body">
        <div className="d-flex flex-column" style={{ flex: 1.5 }}>
          <div className="d-flex" style={{ flex: 1, margin: 5, position: "relative" }}>
            <div style={{ minWidth: '50%', position: 'relative', margin: 'auto', height: '95%' }} className="mt-0 me-1 mb-0">
              <BarChartDemandCusType
                data={dataListGraph}
                date={props.date}
              />
            </div>
            <div style={{ minWidth: '50%', borderLeft: "2px solid #4A5576", position: 'relative', margin: 'auto', height: '95%' }} className="mt-0 mb-0">
              <ByPassChart
                date={props.date}
                data={dataListGraphByPassGas}
                summaryReportPid={props.summaryReportPid}
              />
            </div>
          </div>
          <div className="d-flex" style={{ flex: 1, margin: 5, position: "relative" }}>
            <div style={{ minWidth: '50%' }} className="mt-0 me-1">
              <TableDemandCom date={props.date} summaryReportPid={props.summaryReportPid} />
            </div>
            <div style={{ minWidth: '50%', borderLeft: "2px solid #4A5576" }} className="mt-0">
              <Row>
                <Col sm="1" />
                <Col sm="10">
                  <hr />
                </Col>
                <Col sm="1" />
              </Row>
              <Row className="mt-0">
                <Col sm="2" />
                <Col sm="10">
                  <h5 style={{ fontSize: "1.3vw", fontWeight: "bold" }}>
                    By Pass Gas
                  </h5>
                </Col>
              </Row>
              <Row className="mt-0">
                <Col sm="6" />
                <Col sm="2">
                  <h5 style={{ fontSize: "1.3vw", fontWeight: "bold" }}>
                    {numberFormat(byPassGas.BYPASSGAS_VOLUME, 0)}
                  </h5>
                </Col>
                <Col sm="4">
                  <h5 className="d-sm-flex align-items-center justify-content-start" style={{ fontSize: "1.3vw", fontWeight: "bold" }}>
                    MMscfd
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col sm="1" />
                <Col sm="10">
                  <hr />
                </Col>
                <Col sm="1" />
              </Row>
              <Row className="mt-0">
                <Col sm="2" />
                <Col sm="6">
                  <h5 style={{ fontSize: "1.3vw", fontWeight: "bold" }}>
                    Event Report
                  </h5>
                </Col>
                <Col sm="4">
                  <h5
                    className="d-sm-flex align-items-center justify-content-start"
                    style={{
                      fontSize: "1.3vw",
                      fontWeight: "bold",
                      color:
                        avgDemandEventModel.AVGDEMAND_STATUS == 1
                          ? "#FF4545"//  FC0404
                          : "#6EF649",
                    }}
                  >
                    {avgDemandEventModel.AVGDEMAND_STATUS == 1
                      ? "Abnormal"
                      : "Normal"}
                  </h5>
                </Col>
              </Row>
              <Row className="mt-0">
                <Col sm="2" />
                <Col sm="8">
                  <Input
                    placeholder="Remark : - "
                    type="textarea"
                    rows="2"
                    style={{
                      border: "solid 1px #FFFFFF",
                      color: "#FFFFFF",
                      resize: "none"
                    }}
                    className="form-control"
                    disabled
                    onChange={e =>
                      setAvgDemandEventModel({
                        ...avgDemandEventModel,
                        AVGDEMAND_REMARK: e.target.value,
                      })
                    }
                    value={avgDemandEventModel.AVGDEMAND_REMARK}
                  />
                </Col>
                <Col sm="2" />
              </Row>
            </div>
          </div>
        </div>
      </div>


      {/* 
        <Row className="mt-2">
          <Col sm="6">
            <Row>
              <BarChartDemandCusType
                data={dataListGraph}
                date={props.date}
              />
            </Row>

            <Row className="mt-3">
              <TableDemandCom date={props.date} summaryReportPid={props.summaryReportPid} />
            </Row>

          </Col>

          <Col sm="6" style={{ borderLeft: "2px solid #4A5576" }}>
            <Row>
              <ByPassChart
                date={props.date}
                data={dataListGraphByPassGas}
              />
            </Row>
            <Row className="mt-3">
              <h5 className="ms-5" style={{ fontSize: "20px" }}>
                By Pass Gas
              </h5>
            </Row>
            <Row className="mt-2">
              <Col sm="4" />
              <Col sm="2">
                <h5 className="ms-5" style={{ fontSize: "20px" }}>
                  {byPassGas.BYPASSGAS_VOLUME}
                </h5>
              </Col>

              <Col sm="6">
                <h5 className="ms-5" style={{ fontSize: "16px" }}>
                  MMscfd
                </h5>
              </Col>
            </Row>
            <Row className="mt-2">
              <hr />
              <Col sm="6">
                <h5 className="ms-5" style={{ fontSize: "20px" }}>
                  Event Report
                </h5>
              </Col>
              <Col sm="6">
                <h5
                  className="ms-5"
                  style={{
                    fontSize: "20px",
                    color:
                      avgDemandEventModel.AVGDEMAND_STATUS == 1
                        ? "#FC0404"
                        : "#14A90A",
                  }}
                >
                  {avgDemandEventModel.AVGDEMAND_STATUS == 1
                    ? "Abnormal"
                    : "Normal"}
                </h5>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col sm="8">
                <Input
                  placeholder="Remark : - "
                  type="textarea"
                  rows="4"
                  style={{
                    border: "solid 1px #FFFFFF",
                    color: "#FFFFFF",
                  }}
                  className="form-control ms-5"
                  disabled
                  onChange={e =>
                    setAvgDemandEventModel({
                      ...avgDemandEventModel,
                      AVGDEMAND_REMARK: e.target.value,
                    })
                  }
                  value={avgDemandEventModel.AVGDEMAND_REMARK}
                />
              </Col>
            </Row>
          </Col>
        </Row> */}
      {/* </Col> */}

    </Row >
  );
}

SectionDemandCustomerType.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionDemandCustomerType;
